import React from "react";
import {
  FormGroup,
  Input,
  Row,
  Col,
} from "reactstrap";

/**
 * SiteStep — wizard step for basic site information.
 *
 * Props:
 *   formData      — the wizard's formData.site slice, e.g.:
 *                   { site_name, address, city, country, postal_code }
 *   updateSection — (section, field, value) => void
 *                   Passed down from SetupWizard to update nested formData.
 */
function SiteStep({ formData = {}, updateSection }) {
  const site = formData.site || {};

  return (
    <div className="pl-lg-4">
      <Row>
        <Col lg="6">
          <FormGroup>
            <label className="form-control-label" htmlFor="input-site_name">
              Site Name <span className="text-danger">*</span>
            </label>
            <Input
              id="input-site_name"
              value={formData.site_information.company_name || ""}
              onChange={(e) => { updateSection("site_information", "company_name", e.target.value)}}
              placeholder="e.g. Acme Corp Main Site"
              type="text"
              required
            />
          </FormGroup>
        </Col>

        <Col lg="6">
          <FormGroup>
            <label className="form-control-label" htmlFor="input-address">
              Address
            </label>
            <Input
              id="input-address"
              value={formData.site_information.address || ""}
              onChange={(e) => { updateSection("site_information", "address", e.target.value)}}
              placeholder="123 Main Street"
              type="text"
            />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col lg="4">
          <FormGroup>
            <label className="form-control-label" htmlFor="input-city">
              City
            </label>
            <Input
              id="input-city"
              value={formData.site_information.city || ""}
              onChange={(e) => { updateSection("site_information", "city", e.target.value)}}
              placeholder="City"
              type="text"
            />
          </FormGroup>
        </Col>

        <Col lg="4">
          <FormGroup>
            <label className="form-control-label" htmlFor="input-country">
              Country
            </label>
            <Input
              id="input-country"
              value={formData.site_information.country || ""}
              onChange={(e) => { updateSection("site_information", "country", e.target.value)}}
              placeholder="Country"
              type="text"
            />
          </FormGroup>
        </Col>

        <Col lg="4">
          <FormGroup>
            <label className="form-control-label" htmlFor="input-postal_code">
              Postal Code
            </label>
            <Input
              id="input-postal_code"
              value={formData.site_information.postal_code || ""}
              onChange={(e) => { updateSection("site_information", "postal_code", e.target.value)}}
              placeholder="Postal code"
              type="text"
            />
          </FormGroup>
        </Col>
      </Row>
    </div>
  );
}

export default SiteStep;